import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const WideViewIconContainer = styled("div", {
    shouldForwardProp: prop => prop !== "showContainer",
})<{showContainer: boolean}>`
    width: auto;
    min-width: 2.75rem;
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
        display: flex;
        justify-content: space-around;
    }

    a:active,
    a:hover,
    a:focus,
    a:active,
    a:hover,
    a:focus,
    a:visited,
    a {
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
    }
`

export const NarrowViewIconContainer = styled("div")`
    height: 2.75rem;
    width: 2.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Wrapper = styled("div", {
    shouldForwardProp: prop => prop !== "usernameVisible",
})<{usernameVisible: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    @media (min-width: ${breakpoints.values.xl}px) {
        padding-right: ${({usernameVisible}) => (usernameVisible ? "0.5rem" : "0")};
    }
`
export const Username = styled(Typography)`
    margin: 0.3rem;
    display: none;
    && {
        text-overflow: ellipsis;
        max-width: 105px;
        width: auto;
        text-align: inherit;
        white-space: nowrap;
        overflow: hidden;
        color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.textColor};

        @media (min-width: ${breakpoints.values.xl}px) {
            white-space: unset;
        }

        @media (min-width: ${breakpoints.values.lg}px) {
            display: block;
        }
    }
`
